import { render, staticRenderFns } from "./SampleMemoryChemical.vue?vue&type=template&id=b6a24ae0&scoped=true"
import script from "./SampleMemoryChemical.vue?vue&type=script&lang=js"
export * from "./SampleMemoryChemical.vue?vue&type=script&lang=js"
import style0 from "./SampleMemoryChemical.vue?vue&type=style&index=0&id=b6a24ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a24ae0",
  null
  
)

export default component.exports